/*
 * Wigvana: hides the Flash Sale option on the Perfect10 price ladder (perfect10-price-ladder.liquid)
 * for shoppers browsing from within a set radius of a physical partner salon. Added 2026-10-18 per
 * merchant request -- see the "PARTNER-SALON GEOFENCE FOR FLASH SALE" note in that snippet for the
 * full rationale. Does NOT touch the separate countdown timer elsewhere on the page.
 *
 * Partner salons currently configured:
 *   1. 702 E. Colorado St., Glendale, CA 91205
 *   2. 73725 El Paseo, Palm Desert, CA 92260
 * To add/remove a salon, edit the SALONS array below (lat/lon only -- no need to touch the Liquid
 * snippet). City/zip-level coordinates are precise enough for a mileage radius this size; exact
 * rooftop coordinates are not required.
 */
(function () {
  var SALONS = [
    { label: 'Glendale, CA 91205 (702 E. Colorado St.)', lat: 34.13679, lon: -118.24339 },
    { label: 'Palm Desert, CA 92260 (73725 El Paseo)', lat: 33.71958, lon: -116.37852 }
  ];
  var RADIUS_MILES = 30;
  var CACHE_KEY = 'wvFlashSaleGeofence';
  var GEO_ENDPOINT = 'https://get.geojs.io/v1/ip/geo.json';

  function toRad(deg) {
    return (deg * Math.PI) / 180;
  }

  function milesBetween(lat1, lon1, lat2, lon2) {
    var earthRadiusMiles = 3958.8;
    var dLat = toRad(lat2 - lat1);
    var dLon = toRad(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return earthRadiusMiles * c;
  }

  function isNearAnySalon(lat, lon) {
    for (var i = 0; i < SALONS.length; i++) {
      if (milesBetween(lat, lon, SALONS[i].lat, SALONS[i].lon) <= RADIUS_MILES) return true;
    }
    return false;
  }

  function hideFlashSale() {
    var groups = document.querySelectorAll('[data-perfect10-flash-sale-group]');
    groups.forEach(function (group) {
      group.style.display = 'none';
      // Without this, a shopper near a partner salon who clicks "Add to Cart" without explicitly
      // picking an option would still silently have the Flash Sale discount code auto-applied by
      // perfect10-price-ladder.liquid's own click handler, which checks this attribute -- not whether
      // the option is visible.
      var optionsRoot = group.closest('[data-testid="perfect10-purchase-options"]');
      if (optionsRoot) optionsRoot.setAttribute('data-perfect30-available', 'false');
    });
  }

  function readCache() {
    try {
      return sessionStorage.getItem(CACHE_KEY);
    } catch (e) {
      return null;
    }
  }

  function writeCache(value) {
    try {
      sessionStorage.setItem(CACHE_KEY, value);
    } catch (e) {}
  }

  // QA/debug override (2026-10-18): lets the merchant force either branch to verify the fix without
  // actually traveling to a salon or spoofing an IP. Append ?wv_debug_geofence=near or =far to the
  // preview URL. Gated on window.Shopify.theme.role !== 'main' so it only ever works on a draft/preview
  // theme -- the moment this theme is published as MAIN, the override stops working on its own, with
  // nothing to remember to remove. Deliberately bypasses the sessionStorage cache in both directions so
  // toggling the param always takes effect immediately and never pollutes real cached results.
  function getDebugOverride() {
    try {
      var role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
      if (role === 'main') return null;
      var override = new URLSearchParams(window.location.search).get('wv_debug_geofence');
      if (override === 'near' || override === 'far') return override;
    } catch (e) {}
    return null;
  }

  function run() {
    var debugOverride = getDebugOverride();
    if (debugOverride === 'near') {
      hideFlashSale();
      return;
    }
    if (debugOverride === 'far') {
      return;
    }

    var cached = readCache();
    if (cached === 'near') {
      hideFlashSale();
      return;
    }
    if (cached === 'far') {
      return;
    }

    // No cached result yet this browser session -- look up the shopper's approximate location once.
    fetch(GEO_ENDPOINT)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var lat = parseFloat(data && data.latitude);
        var lon = parseFloat(data && data.longitude);
        var near = !isNaN(lat) && !isNaN(lon) && isNearAnySalon(lat, lon);
        writeCache(near ? 'near' : 'far');
        if (near) hideFlashSale();
      })
      .catch(function () {
        // Fail OPEN: if the geolocation lookup fails (network issue, geojs.io outage, etc.), leave the
        // Flash Sale option visible rather than risk hiding a real promotion store-wide. Deliberately
        // not cached, so it retries on the next page view instead of getting stuck.
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
